/** 掲載終了時は false に変更 */
export const IMPORTANT_NOTICE_ENABLED = true;

export const IMPORTANT_NOTICE_TITLE = 'オンサイトカードサイト障害のお詫び/新規会員登録のお願い';

/** 段落ごとの行配列（1要素なら1行、複数要素は改行でつなぐ） */
export const IMPORTANT_NOTICE_PARAGRAPHS: string[][] = [
  [
    '平素よりオンサイトカードをご利用いただき、誠にありがとうございます。',
  ],
  [
    'この度は、弊社が利用している某社のサーバーシステム障害により、3月26日（木）よりオンラインサイトがご利用いただけない状態が続きました。お客様には多大なるご不便とご心配をおかけしまして、深くお詫び申し上げます。',
  ],
  [
    '復旧後の調査により、弊社システムデータおよびバックアップファイルに一部破損が発生していることが判明いたしました。本件につきまして、速やかにデータの完全な復旧を試みましたが、困難であるとの判断に至りました。',
  ],
  [
    'そのため、お客様の個人情報保護およびサービスの安全性確保を最優先とし、システムの全面的なリニューアルを実施いたしました。これに伴い、以下のデータをリセットしており、すべてのお客様は、新たに会員登録が必要となっております。（現在は、退会と同じ状態）',
  ],
  [
    '・すべての会員情報（氏名、ご連絡先、住所）',
    '・取得済みのカードアルバム及びその他履歴',
  ],
  [
    '※お客様の個人情報およびクレジットカード情報の漏洩等の事実は確認されませんでしたので、ご安心頂ければ幸いです。',
    '※また、本件に関して、ご不明な点や不具合・返金処理などのサポートが必要な方は、下記までお気軽にご連絡をお願いいたします。',
  ],
  [
    '■お問い合わせ先',
    'メールアドレス：info@pbridge.net',
    '電話番号：06-6395-0945（平日13：00～17：00、土日祝休み）',
  ],
  [
    '【X（旧ツイッター）のDMでも承ります。】',
    'all_team_onsite_card_official',
    '@all_onsite_card',
  ],
  [
    '※リニューアル前にご利用いただいていたお客様につきましては、退会手続きは不要です。',
    '※対応期限は2026年7月31日までとさせていただきます。',
  ],
];
